module.exports = __webpack_public_path__ + "static/media/labor-law.bd8cd686.jpg";